import React, { Component } from 'react';
import { firebaseApp} from '../../firebase'
import Loader from 'react-loader-spinner'
// import { MuiThemeProvider } from '@material-ui/styles'
import CircularProgress from '@material-ui/core/CircularProgress'
import Button from '@material-ui/core/Button';
import { observer } from 'mobx-react';

const DealForm = observer( class DealForm extends Component {
	constructor(){
    super()

    this.handleEvent = this.handleEvent.bind(this)
    this.readImage = this.readImage.bind(this)
    this.updateProgress = this.updateProgress.bind(this)
    this.finalizeUpload = this.finalizeUpload.bind(this)
    this.addToUi = this.addToUi.bind(this)
    this.addCategory = this.addCategory.bind(this)
    this.addDays = this.addDays.bind(this)
    this.addTime = this.addTime.bind(this)
    this.addAge = this.addAge.bind(this)
    this.addSavings = this.addSavings.bind(this)
    this.changeAddress = this.changeAddress.bind(this)
    this.addDates = this.addDates.bind(this)
    this.modal = this.modal.bind(this)
    this.changeVendorName = this.changeVendorName.bind(this)
    this.addURL = this.addURL.bind(this)

		// TEST
		this.getGeo = this.getGeo.bind(this)

  }

  mongo = process.env.REACT_APP_MONGO
  state = {
      storage: false,
      image: '',
      spinner: false,
      imageUrl: false,
      imageFile: '',
      progress: 0,
      imageUploaded: false,
      signup_url: null,
      downloadURL: null,
      formData: {
        imageUrl: null
      },
      vendor: null,
      vendor_name: '',
      dealTitle:'',
      title:'',
      description: '',
      categories: {
        eat: false,
        play: false,
        parents: false
      },
      days: {
        Monday: false,
        Tuesday: false,
        Wednesday: false,
        Thursday: false,
        Friday: false,
        Saturday: false,
        Sunday: false,
        any_day: false
      },
      time: {
        all_day: false,
        morning: false,
        afternoon: false,
        evening: false,
        custom_time: false
      },
      age: {
        zeroTwo:false,
        threeSix: false,
        sevenTen: false,
        elevenSeventeen: false,
        eighteenPlus: false
      },
      percent: null,
      price: null,
      start_date: null,
      expiration: null,
      modal: false,
			free: false
    }
  progress = 0


  async componentDidMount(){

		let { mainStore } = this.props.myStores;
		let { authUser } = mainStore;

		var url = "https://us-central1-funily-deals.cloudfunctions.net/getVendor";
		// var url = "http://localhost:5000/funily-deals/us-central1/getVendor";

		let options = {
			method: "POST",
			mode: 'no-cors',
			body: JSON.stringify({
				uid: authUser.uid
			})
		}

		var getVendor = await fetch(url,{
			method: "POST",
			headers: {
				Accept: 'application/json',
				'Content-Type': 'application/json'
			},
			body: JSON.stringify({
				uid: authUser.uid
			})
		});

		var response = await getVendor.json();

		this.setState({
			vendor: response.message,
			address: response.message.address,
			vendor_name: response.message.vendor
		})
  }

  modal(){
    this.setState({
      storage: false,
      image: '',
      spinner: false,
      imageUrl: false,
      imageFile: '',
      progress: 0,
      imageUploaded: false,
      formData: {
        imageUrl: null
      },
      dealTitle:'',
      title:'',
      description: '',
      categories: {
        eat: false,
        play: false,
        parents: false
      },
      days: {
        Monday: false,
        Tuesday: false,
        Wednesday: false,
        Thursday: false,
        Friday: false,
        Saturday: false,
        Sunday: false,
        any_day: false
      },
      time: {
        all_day: false,
        morning: false,
        afternoon: false,
        evening: false,
        custom_time: false
      },
      age: {
        all_ages:false,
        teens: false,
        pre_teens: false,
        toddlers: false,
        infants: false,
        custom_age: false
      },
      signup_url: null,
      percent: null,
      price: null,
      start_date: null,
      expiration: null,
      modal: false
    })
  }

  addCategory(e){
    let cat = e.target.name
    let categories = this.state.categories
    console.log(document.getElementById(e.target.id).value)
    if(cat === 'all-cats'){
      if(document.getElementById(e.target.id).checked){
        categories.play = true
        categories.eat = true
        categories.parents = true
        this.setState({categories})
      }else{
        categories.play = false
        categories.eat = false
        categories.parents = false
        this.setState({categories})
      }

    } else {
      if(document.getElementById(e.target.id).checked){
        categories[e.target.id] = true
        this.setState({categories})
      }else{
        categories[e.target.id] = false
        this.setState({categories})
      }
    }

  }

  addDays(e){
    let day = e.target.name
    let days = this.state.days
    if(day === "any_day"){
      if(document.getElementById(day).checked){
        days[day] = true
        days.Monday = true
        days.Tuesday = true
        days.Wednesday = true
        days.Thursday = true
        days.Friday = true
        days.Saturday = true
        days.Sunday = true

      } else {

        days[day] = false
        days.Monday = false
        days.Tuesday = false
        days.Wednesday = false
        days.Thursday = false
        days.Friday = false
        days.Saturday = false
        days.Sunday = false

      }
      this.setState({days})

    } else {

      if(document.getElementById(day).checked){
        days[day] = true

      } else {
        days[day] = false
      }

      this.setState({days})

    }



  }

  addTime(e){
    let targetTime = e.target.name
    let time = this.state.time
    let val = e.target.value

    if(targetTime === "custom_time"){
      time[targetTime] = val
      time.all_day = false
      time.morning = false
      time.afternoon = false
      time.evening = false
      this.setState({time},()=> console.log(this.state.time))
    } else if(targetTime === "all_day"){
      if(document.getElementById(targetTime).checked){
        time.all_day = true
        time.morning = true
        time.afternoon = true
        time.evening = true

        this.setState({time})
      } else {
        time.all_day = false
        time.morning = false
        time.afternoon = false
        time.evening = false

        this.setState({time})
      }
    } else {
      if(document.getElementById(targetTime).checked){
        time[targetTime] = true
        this.setState({time})
      }else{
        time[targetTime] = false
        this.setState({time})
      }
    }

  }

  addAge(e){
    let age = this.state.age
    let ageGroup = e.target.name
    let val = e.target.value

    if(ageGroup === 'custom_age'){

      age[ageGroup] = val
      age.all_ages = false
      age.adults = false
      age.teens = false
      age.pre_teens = false
      age.toddlers = false
      age.infants = false
			age.zeroTwo = false
			age.threeSix = false
			age.sevenTen = false
			age.elevenSeventeen = false
			age.eighteenPlus = false
      this.setState({age},()=> console.log(this.state.age))

    } else {

      if(ageGroup === "all_ages") {
        if(document.getElementById(ageGroup).checked){
          age[ageGroup] = true
          age.adults = true
          age.teens = true
          age.pre_teens = true
          age.toddlers = true
          age.infants = true
        }else{
          age[ageGroup] = false
          age.adults = false
          age.teens = false
          age.pre_teens = false
          age.toddlers = false
          age.infants = false
        }
        this.setState({age},()=> console.log(this.state.age))

      } else {

        if(document.getElementById(ageGroup).checked){
          age[ageGroup] = true
        } else {
          age[ageGroup] = false
        }
        this.setState({age},()=> console.log(this.state.age))
      }

    }

  }

  addSavings(e) {
    let saving = e.target.name
    let val = null

    if(saving === "price"){
      val = e.target.value
      this.setState({price: val})
    } else {
      if(e.target.value){
        val = e.target.value + "%"
      }
      this.setState({percent: val})
    }

  }

  addURL(e){
    let signup_url = e.target.value
    this.setState({signup_url},()=> console.log(this.state.signup_url))
  }

  readImage(e){

    let files = e.target.files
    let imageUrl = null
    let downloadURL = null
    //let img = document.createElement('img')

    // stop everything if cancel was clicked and no image
    if(files.length <= 0){
      return
    }


    // if user changes the file grab the recent file
    const file =  files.length > 0 ? files[files.length -1]
                                   : files[0]

		let imageFile = file

    var reader = new FileReader();
    reader.onload = function(e){
      // document.getElementById('promo_img').src = e.target.result
      var img = new Image()

      img.onload = function(){

        var canvas = document.createElement("canvas");

        let ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0);

        var MAX_WIDTH = 720;
        var MAX_HEIGHT = 720;
        var width = img.width;
        var height = img.height;

        if (width > height) {

          if (width > MAX_WIDTH) {
            height *= MAX_WIDTH / width;
            width = MAX_WIDTH;
          }

        } else {

          if (height > MAX_HEIGHT) {
            width *= MAX_HEIGHT / height;
            height = MAX_HEIGHT;
          }

        }

        canvas.width = width;
        canvas.height = height;
        ctx = canvas.getContext("2d");
        ctx.drawImage(img,0,0,width,height);

        var dataurl = canvas.toDataURL();
				var imageData = dataurl.split(',')[1];

        let filename = this.state.vendor.email + Math.random().toString(36).substring(2, 10);

				var functionUrl = "https://us-central1-funily-deals.cloudfunctions.net/uploadPromoImage";

				var options = {
					method: "POST",
					body: JSON.stringify({
						title: filename,
						data: imageData
					})
				}

				//  FETCH IMAGE URL
				fetch(functionUrl,options)
				.then(res => res.json())
				.then(function (json) {
					this.setState({
						imageUploaded: true,
						downloadURL: json.url
					},() => {
						document.getElementById('promo_img').src = this.state.downloadURL;
						setTimeout(function() {
							this.setState({imageUpload: false})
						}.bind(this), 3000)
					})
				}.bind(this))
				.catch(err => console.log(err));

      }.bind(this) // image on load

        img.src = e.target.result

    }.bind(this) // reader.onload

      reader.readAsDataURL(file)

   }

  updateProgress(progress){
    this.setState({progress})
  }

  finalizeUpload(formData){
    console.log(formData)
  }

	async getGeo() {
		var geoCode = "https://us-central1-funily-deals.cloudfunctions.net/geoCode";
		var geoOptions = {
			method: "POST",
			body: JSON.stringify({
				location:this.state.address
			})
		}
		let location = {};
		location.type = "Point";

		try {

			let fetchGeo = await fetch(geoCode,geoOptions);
			let geoJson = await fetchGeo.json();
			let currentLocation = [geoJson.location.coordinates[1],geoJson.location.coordinates[0]];
			location.coordinates = currentLocation;

			console.log(location);

		} catch (e) {
			throw e;
		}

	}

  async handleEvent(e){
		e.persist();
    e.preventDefault()
		let { myStores } = this.props;
		let { mainStore } = myStores;

    let formData = this.state.formData
    this.setState({spinner: true})
    for(const field in this.refs){
      formData[field] = this.refs[field].value
    }

    let data = {
        age: this.state.age,
        category: this.state.categories,
        createAt: new Date(this.state.expiration),
        mili: new Date(this.state.expiration).getTime(),
        list_mili: new Date(this.state.list_date).getTime(),
        days: this.state.days,
        deal_code: Math.random().toString(36).slice(2,10) + Math.random().toString(36).slice(2,10),
        dealTitle: this.state.dealTitle,
        description: this.state.description,
        expiration: this.state.expiration,
        percent: this.state.percent,
        price: Number(this.state.price) * 100,
        start_date: this.state.start_date,
        list_date: this.state.list_date,
        time: this.state.time,
        vendor: this.state.vendor_name,
        uid: mainStore.authUser.uid,
        email: mainStore.authUser.email,
        address: this.state.address,
        downloadURL: this.state.downloadURL,
        keywords: formData.keywords,
        count: 0,
        signup_url: this.state.signup_url,
				free: this.state.free
    }

		var geoCode = "https://us-central1-funily-deals.cloudfunctions.net/geoCode";
		var geoOptions = {
			method: "POST",
			body: JSON.stringify({
				location:this.state.address
			})
		}

		var saveToMongo = "https://us-central1-funily-deals.cloudfunctions.net/saveToMongo";

		try {

			//  GET COORDINATES
			let fetchGeo = await fetch(geoCode,geoOptions);
			let geoJson = await fetchGeo.json();
			let currentLocation = [geoJson.location.coordinates[1],geoJson.location.coordinates[0]];

			data.location = {
				type: 'Point',
				coordinates: currentLocation
			}

			//  SAVE TO MONGO
			let saveEvent = await fetch(saveToMongo,{
				method: 'Post',
				body: JSON.stringify({
					collection: 'preStaged',
					toSave: data
				})
			})

			let jsonRes = await saveEvent.json();

			this.setState({spinner:false,modal:true}, () => {
				console.log('response from mongo', jsonRes);
			})


		} catch (err) {

			this.setState({spinner:false,modal:true},() => {
				console.log('error saving deal to mongo',err)
			})

		}

    // reset form
    e.target.reset()
  }

  addToUi(e){
    let val = e.target.value
    let item = e.target.name
    if(e.target.name === 'dealTitle'){
      document.getElementById('dealTitle').innerHTML = val
      this.setState({dealTitle: val})
    }
    if(e.target.name === 'description'){
      document.getElementById('descriptionHolder').innerHTML = val
      this.setState({description: val})
    }
  }

  changeAddress(e){
    let address = e.target.value
    this.setState({address},()=> console.log(this.state.address))
  }

  changeVendorName(e){
    let vendor_name = e.target.value
    this.setState({vendor_name},()=> console.log(this.state.vendor_name))
  }

  addDates(e) {
    let date_type = e.target.name
    let val = e.target.value
    console.log(val)

    if(date_type === "start_date"){
      this.setState({start_date: val})
    }else if(date_type === 'expiration'){
      this.setState({expiration: val})
    }else {
      this.setState({list_date: val})
    }
  }

  directions(){
    alert('When users click this button, it will open their phone\'s map and provide directions to your location.')
  }

  signUpURL(){
    alert('When users click this button, it will open their phone\'s browser and take them to the URL that you entered in the form.')
  }

  redeemNow() {
    alert('When users click this button, a redemption code is generated specifically for the user.  They are required to confirm the redemption before it is finalized and counted in our database.  The deal is also saved on their phone so that they can access the redemption code when they arrive at your location.')
  }

  saveForLater() {
    alert('When users click this button, the deal is saved on their phone so that they can easily access the deal\'s information later or redeem the code.')
  }

  render() {

    let { custom_time } = this.state.time
    let { custom_age } = this.state.age
    let address = this.state.vendor ? this.state.address : ''
    let vendor = this.state.vendor_name ? this.state.vendor_name : ''

    return (
      <div className='container col-md-12'>
      <div className='col-md-6' style={{backgroundColor: 'lightgrey', paddingTop: '20px', paddingBottom: '20px'}}>
      <form onSubmit={this.handleEvent}>

        <div className='form-group'>
        <input
					className='form-control'
					type='text'
					name='vendor-name'
					ref='vendor-name'
					placeholder='Vendor Name'
					value={vendor}
          onChange={this.changeVendorName}
          required
        />
        </div>
        <div className='form-group'>
        <input className='form-control' type='text' name='dealTitle' placeholder='Event Title'
        onChange={this.addToUi}
        autoFocus required/>
        </div>

        <div className='form-group'>
        <label htmlFor='address'>Promotion Image</label>
        <div className='form-group'>
        <CircularProgress variant='determinate' value={this.state.progress} />
        </div>
        {
          (this.state.imageUploaded) ?
          <div>
          <p style={{color:'red'}}>Image Uploaded</p>
          </div>
          : null
        }
        <input className='form-control' type='file' name='image' ref='image' onChange={this.readImage} required/>
        </div>

				<div className='form-group'>
					<div className='checkbox'>
						<label>
							<input checked={this.state.free} type="checkbox" name='free' value='free' id='free' onClick={() => this.setState({free:!this.state.free},() => console.log('free: ' + this.state.free))}  /> Free
						</label>
					</div>
				</div>

        <div className='form-group'>
        <h4 className='text-center'>Funily Category</h4>
          <div className="checkbox">
            <label>
              <input checked={this.state.categories.eat} type="checkbox" name='eat' value='eat' id='eat' onClick={this.addCategory}  /> Eat
            </label>
          </div>
          <div className="checkbox">
            <label>
              <input checked={this.state.categories.play} type="checkbox" name='play' value='play' id='play' onClick={this.addCategory} /> Play
            </label>
          </div>
          <div className="checkbox">
            <label>
              <input checked={this.state.categories.parents} type="checkbox" name='parents' value='parents' id='parents' onClick={this.addCategory}/> Parents' Night Out
            </label>
          </div>
          <div className="checkbox">
            <label>
              <input type="checkbox" name='all-cats' id='all-cats' onClick={this.addCategory} /> All of the Above
            </label>
          </div>
        </div>

        <div className='form-group'>
          <h4 className='text-center'>Days Category</h4>
          <div className="checkbox">
            <label>
              <input checked={this.state.days.Monday} type="checkbox" name='Monday' value='Monday' id='Monday' onClick={this.addDays}/> Monday
            </label>
          </div>
          <div className="checkbox">
            <label>
              <input checked={this.state.days.Tuesday} type="checkbox" name='Tuesday' value='Tuesday' id='Tuesday' onClick={this.addDays}/> Tuesday
            </label>
          </div>
          <div className="checkbox">
            <label>
              <input checked={this.state.days.Wednesday} type="checkbox" name='Wednesday' value='Wednesday' id='Wednesday' onClick={this.addDays}/> Wednesday
            </label>
          </div>
          <div className="checkbox">
            <label>
              <input checked={this.state.days.Thursday} type="checkbox" name='Thursday' value='Thursday' id='Thursday' onClick={this.addDays}/> Thursday
            </label>
          </div>
          <div className="checkbox">
            <label>
              <input checked={this.state.days.Friday} type="checkbox" name='Friday' value='Friday' id='Friday' onClick={this.addDays}/> Friday
            </label>
          </div>
          <div className="checkbox">
            <label>
              <input checked={this.state.days.Saturday} type="checkbox" name='Saturday' value='Saturday' id='Saturday' onClick={this.addDays}/> Saturday
            </label>
          </div>
          <div className="checkbox">
            <label>
              <input checked={this.state.days.Sunday} type="checkbox" name='Sunday' value='Sunday' id='Sunday' onClick={this.addDays}/> Sunday
            </label>
          </div>
          <div className="checkbox">
            <label>
              <input type="checkbox" name='any_day' value='any_day' id='any_day' onClick={this.addDays}/> Any Day
            </label>
          </div>
        </div>

        <div className='form-group'>
        <h4 className='text-center'>Time Category</h4>
          <div className="checkbox">
            <label>
              <input type="checkbox" name='all_day' value='all_day' id='all_day' onClick={this.addTime}
              disabled={custom_time}
              /> All Day
            </label>
          </div>
          <div className="checkbox">
            <label>
              <input checked={this.state.time.morning} type="checkbox" name='morning' value='morning' id='morning' onClick={this.addTime}
              disabled={custom_time}
              /> Morning
            </label>
          </div>
          <div className="checkbox">
            <label>
              <input checked={this.state.time.afternoon} type="checkbox" name='afternoon' value='afternoon' id='afternoon' onClick={this.addTime}
              disabled={custom_time}
              /> Afternoon
            </label>
          </div>
          <div className="checkbox">
            <label>
              <input checked={this.state.time.evening} type="checkbox" name='evening' value='evening' id='evening' onClick={this.addTime}
              disabled={custom_time}
              /> Evening
            </label>
          </div>
          <div>
            <input className="form-control" type='text' name='custom_time' placeholder="ENTER specific timeframe (i.e. 8:00am-3:30pm)" id='custom_time' onChange={this.addTime} />
          </div>
        </div>

        <div className='form-group'>
        <h4 className='text-center'>Age Group</h4>

					<div className="checkbox">
						<label>
							<input type="checkbox" name='zeroTwo' value='zeroTwo' id='zeroTwo' onClick={this.addAge} disabled={custom_age}/> 0-2 yrs. old
						</label>
					</div>

					<div className="checkbox">
						<label>
							<input type="checkbox" name='threeSix' value='threeSix' id='threeSix' onClick={this.addAge} disabled={custom_age}/> 3-6 yrs. old
						</label>
					</div>

					<div className="checkbox">
						<label>
							<input type="checkbox" name='sevenTen' value='sevenTen' id='sevenTen' onClick={this.addAge} disabled={custom_age}/> 7-10 yrs. old
						</label>
					</div>

					<div className="checkbox">
						<label>
							<input type="checkbox" name='elevenSeventeen' value='elevenSeventeen' id='elevenSeventeen' onClick={this.addAge} disabled={custom_age}/> 11-17 yrs. old
						</label>
					</div>

					<div className="checkbox">
						<label>
							<input type="checkbox" name='eighteenPlus' value='eighteenPlus' id='eighteenPlus' onClick={this.addAge} disabled={custom_age}/> 18+ yrs. old
						</label>
					</div>

					<div>
            <input className="form-control" type='text' name='custom_age' placeholder="ENTER CUSTOM AGE GROUP" id='custom_age' onChange={this.addAge} />
          </div>

        </div>

        <h4 className='text-center'>Enter Price or Percent Savings</h4>
        <p className='text-center'>Please be advised that if you put 0 (zero) as a value in either price or percent, your deal/promo will result in not having a "redeem" button in our app.  It is deemed as a free event that requires no redemption.</p>
        <div className='container col-md-12'>
          <div className='col-md-6'>
            <div className='input-group'>
            <span className="input-group-addon">$</span>
            <input className='form-control' style={{marginRight: 20, width: 150}}  type='number' step='.01' name='price' id='price' ref='price' placeholder='Price (19.99)' onChange={this.addSavings}
            disabled={this.state.percent}
            />
            </div>
          </div>

          <div className='form-group col-md-6'>
            <div className='input-group'>
            <input className='form-control text-center' type='text' name='percent' id='percent' ref='percent' placeholder='Percent (25)' onChange={this.addSavings}
            disabled={this.state.price}
            />
            <span className='input-group-addon'>%</span>
            </div>
          </div>

        </div>
        <h4 className='text-center'>KeyWords</h4>
        <p className='text-center'>Keywords make it easier for users to find your deals.  Enter words that identifies with your business and what you offer.  Separate them with a comma. </p>
        <div className='form-group'>
          <input className='form-control' type='text' name='keywords' ref='keywords' placeholder='ENTER keywords (i.e. jump,sports,wings,etc)' />
        </div>

        <div className='form-group'>
        <label htmlFor='list_date'>List Date</label>&nbsp;&nbsp;
        <input type='date' id='list_date' name='list_date' ref='list_date' onChange={this.addDates} required/>
        <p>This is the date that you would like the listing to start appearing on our app.</p>
        </div>

        <div className='form-group'>
        <label htmlFor='start'>Start Date</label>&nbsp;&nbsp;
        <input type='date' id='start_date' name='start_date' ref='start_date' onChange={this.addDates} required/>
        </div>

        <div className='form-group'>
        <label htmlFor='expire'>Expiration Date</label>&nbsp;&nbsp;
        <input type='date' id='expiration' name='expiration' ref='expiration' onChange={this.addDates} required />
        </div>


        <div className='form-group'>
        <textarea className='form-control'
                  name='description'
                  ref='description'
                  rows={10}
                  placeholder='Enter Details about your deals or paste company information.'
                  onChange={this.addToUi}
        ></textarea>

        <p style={{textAlign: 'center'}}>Enter a URL below if users are required to sign-up via an external website.  Please make sure that you include the "http" or "https" portion of the url.  For example, <span style={{color: 'red'}}>"myfunily.com"</span> would not be a valid URL while <span style={{color: 'green'}}>https://myfunily.com"</span> is a valid URL.</p>

        <input
              className='form-control'
              type='url'
              name='signup_url'
              ref='signup_url'
              onChange={this.addURL}
              placeholder='ENTER URL (MUST include "http" or "https")'
        />
        </div>

        <div className='form-group'>

        </div>

        <div className='form-group'>
        <label htmlFor='address'>Business Address</label>
        <textarea className='form-control'
                  name='address'
                  ref='address'
                  value={address}
                  onChange={this.changeAddress}
									// onBlur={this.getGeo}
                  required
        >
        </textarea>
        </div>
        <button className='btn btn-success btn-block' type='submit'>Submit</button>
      </form>
      </div>

      <div className='col-md-4 col-md-offset-1'
           style={styles.preview}>
      <h4 className='text-center text-primary'>Event Preview</h4>

      <div className='row text-center' >
      <img className='text-center' src={require('../../images/funilylogo.png')} alt='image placeholder' style={styles.imageHolder} id='promo_img' />
      </div>

      <div className='row' >
        <div className='col-md-6'>
          <p style={styles.company}>{vendor}</p>
          <p>{this.state.price
              ? "$" + this.state.price
              : this.state.percent} Off</p>
          <p>0.00mi</p>
          <p>
          {this.state.categories.eat ? "Eat  " : null}
          <span> | </span>
          {this.state.categories.play ? "Play  " : null}
          <span> | </span>
          {this.state.categories.parents ? "Parents' Night Out " : null}
          </p>
        </div>
        <div className='col-md-6'>
          <p style={styles.dealTitle} id='dealTitle'>Deal Title</p>
          <div className="row" style={{paddingRight: "5px"}}>
          <button className='btn btn-primary btn-block' onClick={this.saveForLater}>Save for Later</button>
          </div>
          <div className="row" style={{marginTop: "10px", paddingRight: "5px"}}>
          <button className='btn btn-default btn-block' onClick={this.redeemNow}>Redeem Now</button>
          </div>
        </div>
      </div>
      <p className='text-center' style={{marginTop: "10px"}}>{this.state.address}</p>
      <p className="text-center" style={{marginTop: "10px", fontWeight: 'bold'}}>Details</p>
      <div className='row' style={{padding: "10px"}}>
      <p>
      <b>Days:</b> {this.state.days.any_day ? "Any Day \n" : null} <span> | </span>
        {this.state.days.Monday ? "Monday\n" : null}<span> | </span>
        {this.state.days.Tuesday ? "Tuesday\n" : null}<span> | </span>
        {this.state.days.Wednesday ? "Wednesday\n" : null}<span> | </span>
        {this.state.days.Thursday ? "Thursday\n" : null}<span> | </span>
        {this.state.days.Friday ? "Friday\n" : null}<span> | </span>
        {this.state.days.Saturday ? "Saturday\n" : null}<span> | </span>
        {this.state.days.Sunday ? "Sunday\n" : null}
      </p>
      <p>
      <b>Time:</b> { this.state.time.all_day ? "All Day\n" : null }<span> | </span>
          { this.state.time.morning ? "Morning\n" : null }<span> | </span>
          { this.state.time.afternoon ? "Afternoon\n" : null }<span> | </span>
          { this.state.time.evening ? "Evening\n" : null }<span> | </span>
          { this.state.time.custom_time ? this.state.time.custom_time : null }

      </p>
      <p>
      <b>Age Group:</b> { this.state.age.custom_age ? this.state.age.custom_age : null }<span> | </span>
          { this.state.age.all_ages ? "All Ages\n" : null }<span> | </span>
          { this.state.age.adults ? "Adults\n" : null }<span> | </span>
          { this.state.age.teens ? "Teens\n" : null }<span> | </span>
          { this.state.age.pre_teens ? "Pre-Teens\n" : null }<span> | </span>
          { this.state.age.toddlers ? "Toddlers\n" : null }<span> | </span>
          { this.state.age.infants ? "Infants\n" : null }
      </p>
      <p><b>Start Date:</b> { this.state.start_date ? this.state.start_date : null }</p>
      <p><b>Expiration Date:</b> { this.state.expiration ? this.state.expiration : null } </p>
      <p id='descriptionHolder'>Descriptions go here!</p>

      {
        this.state.signup_url ?
        <div style={{marginBottom: 10}}>
          <p style={{textAlign: 'center'}}>Click on blue sign-up button below.</p>
          <button onClick={this.signUpURL} className='btn btn-primary btn-block'>{this.state.signup_url}</button>
        </div>
        : null
      }

      <button onClick={this.directions} className='btn btn-success btn-block'>Directions</button>
      </div>

      </div>

      {
        this.state.spinner ? <Loader
                                 type="Ball-Triangle"
                                 color="#00BFFF"
                                 height="100"
                                 width="100"
                              />
                            : null
      }

      {
        this.state.modal ?
        <div style={styles.modal}>
          <p className='text-center' style={{color: 'white'}}>
            Your deal has been sent in for review.  Please allow 24 hours for the deal to show up in the Funily App.  Thank you.
          </p>
          <Button
            variant='raised'
            style={{fontSize: 25,paddingTop:10}}
            onClick={this.modal}
          >Got It</Button>
        </div>
        : null
      }


      </div>
    )
  }
})

const styles = {
  company: {
    fontSize: "1em"
  },
  dealTitle: {
    fontSize: '1.5em'
  },
  modal: {
    display: 'flex',
    padding: 10,
    flexDirection: 'column',
    fontSize: "1.5em",
    //color: "white",
    justifyContent: 'center',
    position: "fixed",
    top: "35%",
    left: "35%",
    marginRight: "auto",
    marginLeft: "auto",
    height: "50%",
    width: "40%",
    backgroundColor: '#113856',
    borderRadius: "5px",
    paddingBottom: 20
  },
  imageHolder: {
    height: "200px",
    width: "100%",
    objectFit: 'contain'
  },
  preview: {
    border: '10px solid black',
    borderRadius: '5px',
    boxShadow: '10px 10px 8px #888888'
  }
}



export default DealForm



// WEBPACK FOOTER //
// ./src/components/vendor/DealForm.js